/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_OtherInputs */

const en_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other...`)
};

const fr_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre...`)
};

const de_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere...`)
};

const it_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro...`)
};

const ru_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другой...`)
};

const es_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro...`)
};

const zh_cn2_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他...`)
};

const ja_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他の...`)
};

const hi_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अन्य...`)
};

const pt_pt2_input_position_x_other = /** @type {(inputs: Input_Position_X_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro...`)
};

/**
* | output |
* | --- |
* | "Other..." |
*
* @param {Input_Position_X_OtherInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_other = /** @type {((inputs?: Input_Position_X_OtherInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_OtherInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_x_other(inputs)
	if (locale === "de") return de_input_position_x_other(inputs)
	if (locale === "it") return it_input_position_x_other(inputs)
	if (locale === "ru") return ru_input_position_x_other(inputs)
	if (locale === "es") return es_input_position_x_other(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_x_other(inputs)
	if (locale === "ja") return ja_input_position_x_other(inputs)
	if (locale === "hi") return hi_input_position_x_other(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_x_other(inputs)
	return en_input_position_x_other(inputs)
});